import React from 'react';

import { WizardScreen, FooterMode } from '../wizard-screen/wizard-screen';
import { WizardLoading } from '../../wizard-loading/wizard-loading';

interface LoadingWizardScreenProps {
  text?: string;
}

export const LoadingWizardScreen = ({ text }: LoadingWizardScreenProps) => {
  return (
    <WizardScreen footerMode={FooterMode.NONE}>
      <WizardLoading text={text} />
    </WizardScreen>
  );
};
